export default __webpack_public_path__ + "static/media/bidBanner.png?.01abb13b";